const store = {
    namespaced: true,
    state() {
        return {
            pageData: null
        }
    },
    getters: {
        getPageData(state) {
            return state.pageData;
        }
    },
    mutations: {
        setPageData(state, data) {
            state.pageData = data;
        }
    },
    actions: {
        async fetchPageData({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/base/order-guide/`
                });
    
                commit('setPageData', res.data[0]);
            } catch (e) {
                console.error(e);
            }
        }
    }
}

export default store